// services/commission-reports.service.ts
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';
import { LocalStorageUtil } from '../utils/local-storage.util';
import { resolveBffUrl } from '../utils/bff-url-resolver.util';

@Injectable({
  providedIn: 'root'
})
export class OauthService extends BaseApiService {

  oauth(token: string): Observable<any> {
    LocalStorageUtil.setAccessToken(token);
    const bffUrl = this.configService.getBffUrlIfLoaded() ?? '';
    if (bffUrl.trim()) {
      this.baseUrl = `${resolveBffUrl(bffUrl, this.configService.isDebugEnabled())}/api`;
    }
    const endpoint = `/oauth`;
    return this.get<any>(endpoint);    
  }
}
